<template>
  <div
    v-show="showApp"
    id="app"
    :class="isPersonal ? 'personal-wrap' : 'default-wrap'"
  >
    <div
      v-if="!isPopularize && !isPersonal"
      id="nav"
    >
      <router-link to="/">
        <div
          v-if="!isUgcIndex"
          class="logo"
          title="元气壁纸"
        />
      </router-link>
      <div class="r">
        <template v-if="userInfo.token">
          <div
            class="user-info"
            @click="handleUserInfoDorgDown"
          >
            <span class="user-face"><img
              v-if="userInfo.avatar"
              :src="userInfo.avatar"
              :alt="userInfo.nickname"
            ></span>
            <span class="nickname">{{ userInfo.nickname }}</span>
          </div>
          <div
            v-if="logoutVisible"
            class="logout-mask"
            @click="handleUserInfoDorgDown"
          />
          <span
            v-if="logoutVisible"
            class="logout"
            @click="handleLogout"
          >退出登录</span>
        </template>
        <span
          v-else
          class="login-btn"
          @click="handleLogin"
        >登录</span>
      </div>
    </div>
    <router-view />
    <Announce v-if="!isUgcIndex && !isPopularize && !isPersonal" />
    <div
      v-if="loginDialogVisible && sharePage"
      class="login-dialog"
    >
      <UserLogin />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EventEmit from '@/utils/EventEmit'
import UserLogin from '@/components/UserLogin'
import Announce from '@/components/Announce'
import wxutil from '@/utils/weiXinUtils.js'
// import weiboUtils from '@/utils/weiboUtils.js'

export default {
  name: 'App',
  components: {
    UserLogin,
    Announce,
  },
  data() {
    return {
      showApp: false,
      logoutVisible: false,
      loginDialogVisible: false,
      isUgcIndex: false,
      sharePage: true,
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
    }),
    isPersonal() {
      if (this.$route.path.includes('personal')) {
        return true
      }

      if (this.$route.path === '/p') {
        return true
      }

      return false
    },
    isPopularize() {
      if (this.$route.path.includes('popularize')) {
        return true
      }
      return false
    },
    isJump() {
      if (this.$route.path.includes('jump')) {
        return true
      }
      return false
    },
  },
  watch: {
    $route() {
      if (this.$route.path === '/creation') {
        this.isUgcIndex = true
      } else if (this.$route.path === '/personal/wallpaper') {
        this.sharePage = false
      } else {
        this.isUgcIndex = false
      }
    },
  },
  beforeMount() {
    const playerVersionMatch = location.search.match(/player_version=([^&]+)/)
    if (playerVersionMatch && playerVersionMatch[1]) {
      const playerVersion = Number(playerVersionMatch[1])
      sessionStorage.setItem('player_version', playerVersion)
    }
  },
  mounted() {
    // 加载微信 js-sdk
    wxutil.init()
    // 加载微博 js-sdk
    // weiboUtils.init()
    this.bind()
    setTimeout(() => {
      this.showApp = true
    }, 250)
    setTimeout(() => {
      // 分享的页面不弹出提示登录框
      if (!this.userInfo.token && !this.isPopularize && !this.isPersonal && !this.isJump) {
        this.loginDialogVisible = true
      }
    }, 600)
  },
  methods: {
    bind() {
      EventEmit.$on('SHOW_LOGIN_DIALOG', () => {
        this.loginDialogVisible = true
      })

      EventEmit.$on('HIDE_LOGIN_DIALOG', () => {
        this.loginDialogVisible = false
      })
    },
    handleLogin() {
      this.logoutVisible = false
      EventEmit.$emit('SHOW_LOGIN_DIALOG')
    },
    handleLogout() {
      this.$store.dispatch('removeUserInfo')
      setTimeout(() => {
        window.location.reload()
      }, 500)
    },
    handleUserInfoDorgDown() {
      this.logoutVisible = !this.logoutVisible
    },
  },
}
</script>

<style lang="scss" scoped>
#nav {
  z-index: 5;
  position: relative;
  width: 1200px;
  margin: 0 auto;
  height: 45px;
  padding: 25px 0 38px;
  .logo {
    float: left;
    width: 80px;
    height: 45px;
    background: url('~@/assets/images/logo.png') 0 0 no-repeat;
    background-size: 100%;
  }
  .r {
    position: relative;
    float: right;
  }
  .user-info {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    .user-face {
      display: inline-block;
      vertical-align: middle;
      width: 32px;
      height: 32px;
      margin-right: 12px;
      background: #fafafa url('~@/assets/images/avatar.png') 0 0 no-repeat;
      background-size: 100%;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
    .nickname {
      color: #fff;
      &::after {
        content: '';
        position: relative;
        top: 5px;
        display: inline-block;
        width: 0;
        height: 0;
        margin-left: 12px;
        border-width: 6px;
        border-style: solid dashed dashed dashed;
        border-color: #fff transparent transparent transparent;
      }
    }
  }
  .login-btn {
    color: #fff;
    cursor: pointer;
  }
  .logout-mask {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  .logout {
    z-index: 2;
    position: absolute;
    right: 0;
    top: 40px;
    width: 80px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    font-size: 12px;
    background: #fff;
    border-radius: 4px;
    color: #333;
    cursor: pointer;
  }
  .btn {
    display: inline-block;
    width: 120px;
    height: 31px;
    margin-left: 12px;
    line-height: 31px;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    background: #F5B903;
    border-radius: 8px;
    color: #333;
    cursor: pointer;
  }
}
.login-dialog {
  z-index: 50;
  position: fixed;
  left: 50%;
  top: 50%;
  margin: -250px 0 0 -175px;
  padding-bottom: 20px;
}
</style>

<style lang="scss">
html, body {
  height: 100%;
}
.default-wrap {
  background: #000;
}
.personal-wrap {
  background: #EFF0F1;
}
#app {
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.static-upload-wrap, .dynamic-upload-wrap {
  .el-upload {
    display: block;
  }
  .el-upload__tip {
    display: none;
  }
  .el-upload-list {
    display: none;
  }
  .el-upload-dragger {
    // display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: auto;
    height: auto;
    border: none;
    &.is-dragover {
      border: none;
    }
  }
  .el-input__inner {
    background-color: #f3f3f3;
    border-color: transparent;
    &:focus {
      border-color: #d5d5d5;
    }
  }
  .el-select {
    display: block;
    .el-input__inner {
      &:focus {
        border-color: #d5d5d5;
      }
    }
  }
}
</style>
